'use es6';

import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIEmptyState from 'UIComponents/empty/UIEmptyState';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIllustration from 'UIComponents/image/UIIllustration';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const CenteredFlexContainer = styled(UIFlex).attrs({
  align: 'center',
  justify: 'center'
}).withConfig({
  displayName: "RestrictedFiltersViewState__CenteredFlexContainer",
  componentId: "sc-1h9xfu-0"
})(["width:100%;height:100%;"]);
const RestrictedFiltersViewState = props => {
  const {
    message
  } = props;
  return /*#__PURE__*/_jsx(CenteredFlexContainer, {
    children: /*#__PURE__*/_jsx(UIEmptyState, {
      layout: "vertical",
      primaryContent: message || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFilters.RestrictedFiltersViewState.message"
      }),
      reverseOrder: true,
      secondaryContent: /*#__PURE__*/_jsx(UIIllustration, {
        name: "lock",
        width: "150px"
      }),
      secondaryContentWidth: 200,
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFilters.RestrictedFiltersViewState.title"
      })
    })
  });
};
RestrictedFiltersViewState.propTypes = {
  message: PropTypes.node
};
export default RestrictedFiltersViewState;